var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C6.34 1 5.8 1.54 5.8 2.2V5.8H2.2C1.54 5.8 1 6.34 1 7C1 7.66 1.54 8.2 2.2 8.2H5.8V11.8C5.8 12.46 6.34 13 7 13C7.66 13 8.2 12.46 8.2 11.8V8.2H11.8C12.46 8.2 13 7.66 13 7C13 6.34 12.46 5.8 11.8 5.8H8.2V2.2C8.2 1.54 7.66 1 7 1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.db5a53417794e75a5a0c8c02e0994804.svg";
export { ForwardRef as ReactComponent };